import { put, select } from 'redux-saga/effects'
import importer from 'common/importer'
const AppointmentsActions = importer('Stores/Appointments/Actions')
const { tokens } = importer('Stores/Users/Select', null)

export default function * success ({res}) {
  yield put(AppointmentsActions.getUpcomingAppointments(res.data.donorSfid))
}
